import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import * as fromStore from '../../_store';
import {Store} from '@ngrx/store';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import * as _ from 'lodash';
import {take} from 'rxjs/operators';
import * as fromGlobalStore from '@ibe/store/index';

@Component({
  selector: 'app-passenger-detail-work',
  templateUrl: './passenger-detail-work.indra.component.html',
  styleUrls: ['./passenger-detail-work.component.scss']
})
export class INDRAPassengerDetailWorkComponent implements OnInit, OnDestroy {

	public form: FormGroup = this.fb.group({
		workTrip:  [null],
	});

	private sub$ = new Subscription();

	private _hasChanges: BehaviorSubject<boolean> = new BehaviorSubject(false);
	get hasChanges(): Observable<boolean> {
		return this._hasChanges.asObservable();
	}

	get hasData(): boolean {
		return !_.isEmpty(this.form.value);
	}

	get hasErrors(): boolean {
		return !_.isEmpty(this.form.errors);
	}

	constructor(
		private fb: FormBuilder,
		private store: Store<fromStore.State>,
		private globalStore: Store<fromGlobalStore.State>
  	) { }

	ngOnInit() {
		this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex)
			.subscribe( passenger => {
					if (passenger) {
						this.mapPassengerToForm(passenger);
						// this.verifyFormValidations();
					}
				}
			)
		);
		this.sub$.add(
			this.form.valueChanges.subscribe(() => this._hasChanges.next(true))
		);

		this.formValueChangesUpdateWorkInfo();
	}
	
	private formValueChangesUpdateWorkInfo() {
		this.sub$.add(
			this.form.get('workTrip').valueChanges.subscribe(() => this.dispatchUpdateWorkInfo())
		);
	}

	private dispatchUpdateWorkInfo() {
		this.store.dispatch(
			new fromStore.UpdateFormChangedAction({ 'updateWorkInfo': true })
		);
	}

	private mapPassengerToForm(data: INDRAPax) {
		this.form.patchValue({ 	
			workTrip : data.workTrip ? 'yes' : 'no'
		}, {emitEvent: false});

	}

	ngOnDestroy() {
		this.sub$.unsubscribe();
	}

	public formWorkErrors(control: string) {
		const errors = [];
		if (Object.is('workTrip', control)) {
			if (this.form.controls[control].hasError('required')) {
				errors.push('bookingDetails.error.selectionRequired');
			}
		}
		return errors.join('; ');
	}

	public clearForm() {
		this.form.reset({emitEvent: false});
	}

	public cancelEdit() {
		this.store.select(fromStore.getSelectedPassengersAtIndex)
			.pipe(take(1)).subscribe((data: INDRAPax) => {
				this.form.reset({
					workTrip : data.workTrip ? 'yes' : 'no'
				}, {emitEvent: false});

				this._hasChanges.next(false);
			});
		this.store.dispatch(
			new fromStore.UpdateFormChangedAction(
				{
					'updateWorkInfo': false,
				}
			)
		);
	}
}
